(function () {
  if (window.__yumecosCustomizeSizeInit) return;
  window.__yumecosCustomizeSizeInit = true;

  const CUSTOMIZE_SIZE_PATTERN = /customize\s*size|custom/i;
  const JAPANESE_CUSTOMIZE_SIZE_PATTERN = /カスタム|カスタマイズ|オーダーメイド/;
  const MIN_USE_DATE_DAYS = 30;
  let updateTimer = null;
  let eventsBound = false;

  function getProductView() {
    return document.querySelector('.productView');
  }

  function getVariantPicker() {
    return getProductView()?.querySelector('variant-radios, variant-selects') || null;
  }

  function getCustomizeForm() {
    return document.querySelector('[data-customize-size-form]');
  }

  function getSizeOptionContainer() {
    return document.querySelector('[data-has-customize-size="true"]');
  }

  function getSelectedSizeValue() {
    const container = getSizeOptionContainer();
    if (!container) return '';

    const checkedRadio = container.querySelector('input[type="radio"]:checked');
    if (checkedRadio) return checkedRadio.value;

    const select = container.querySelector('select');
    if (select) return select.value;

    return '';
  }

  function getFormConfig() {
    const form = getCustomizeForm();
    const localeCode = form?.dataset.locale || 'en';
    const locale = localeCode === 'ja' ? 'ja-JP' : localeCode;

    return {
      useDateKey: form?.dataset.propertyUseDate || 'Use Date',
      dressSizeKey: form?.dataset.propertyDressSize || 'Dress Size',
      validationRequired: form?.dataset.msgValidationRequired || 'Please fill in all customize size measurements.',
      validationUseDate: form?.dataset.msgValidationUseDate || 'Use Date must be at least 30 days from today.',
      locale
    };
  }

  function getCustomizeSizePatterns() {
    const raw = getCustomizeForm()?.dataset.customizeSizePatterns || '';
    return raw.split(',').map((item) => item.trim()).filter(Boolean);
  }

  function getCustomizeSizeValues() {
    const raw = getCustomizeForm()?.dataset.customizeSizeValues || '';
    return raw.split('|').filter(Boolean);
  }

  function isCustomizeSizeValue(value) {
    const normalized = String(value || '').trim();
    if (!normalized) return false;
    const normalizedLower = normalized.toLowerCase();

    const configured = getCustomizeSizeValues();
    if (configured.length) {
      return configured.some((item) => item === normalized);
    }

    const patterns = getCustomizeSizePatterns();
    if (patterns.some((pattern) => {
      const patternLower = pattern.toLowerCase();
      return normalizedLower.includes(patternLower) || normalized.includes(pattern);
    })) {
      return true;
    }

    return CUSTOMIZE_SIZE_PATTERN.test(normalized) || JAPANESE_CUSTOMIZE_SIZE_PATTERN.test(normalized);
  }

  function isCustomizeSizeActive() {
    return isCustomizeSizeValue(getSelectedSizeValue());
  }

  function formatDateInputValue(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  function getMinUseDate() {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + MIN_USE_DATE_DAYS);
    return formatDateInputValue(date);
  }

  function getUseDateField() {
    return getCustomizeForm()?.querySelector('[data-customize-use-date]');
  }

  function isUseDateAllowed(value) {
    if (!value) return false;
    const selected = new Date(value + 'T00:00:00');
    if (Number.isNaN(selected.getTime())) return false;
    const minDate = new Date(getMinUseDate() + 'T00:00:00');
    return selected >= minDate;
  }

  function updateUseDateConstraints() {
    const useDateField = getUseDateField();
    if (!useDateField) return;

    const minDate = getMinUseDate();
    useDateField.min = minDate;

    if (useDateField.value && !isUseDateAllowed(useDateField.value)) {
      useDateField.value = '';
      useDateField.classList.remove('is-invalid');
    }
  }

  function formatUseDate(value) {
    if (!value) return value;
    const date = new Date(value + 'T00:00:00');
    if (Number.isNaN(date.getTime())) return value;
    const locale = getFormConfig().locale;
    return date.toLocaleDateString(locale, { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function getValidationRequiredMessage() {
    return getFormConfig().validationRequired;
  }

  function getValidationUseDateMessage() {
    return getFormConfig().validationUseDate;
  }

  function syncGenderProperty() {
    const form = getCustomizeForm();
    if (!form) return;

    const genderField = form.querySelector('[data-customize-gender-property]');
    const dressSizeField = form.querySelector('[data-customize-dress-size-property]');
    const { dressSizeKey } = getFormConfig();

    if (dressSizeField && isCustomizeSizeActive()) {
      dressSizeField.value = getSelectedSizeValue() || getCustomizeSizeValues()[0] || dressSizeKey;
    }

    if (!genderField) return;

    const picker = getVariantPicker();
    if (!picker) return;

    let genderValue = '';

    picker.querySelectorAll('fieldset:not([data-has-customize-size]) input[type="radio"]:checked').forEach((radio) => {
      const optionName = (radio.name || '').toLowerCase();
      if (optionName.includes('gender') || optionName.includes('性别') || optionName.includes('性別')) {
        genderValue = radio.value;
      }
    });

    if (!genderValue) {
      picker.querySelectorAll('select').forEach((select) => {
        if (select.closest('[data-has-customize-size="true"]')) return;
        const selectName = (select.name || '').toLowerCase();
        if (selectName.includes('gender') || selectName.includes('性别') || selectName.includes('性別')) {
          genderValue = select.value;
        }
      });
    }

    genderField.value = genderValue;
  }

  function setFormState(active) {
    const panel = getCustomizeForm();
    if (!panel) return;

    panel.hidden = !active;
    panel.classList.toggle('is-active', active);

    panel.querySelectorAll('[data-customize-field], [data-customize-size-property]').forEach((field) => {
      field.disabled = !active;
      if (active && field.hasAttribute('data-customize-required')) {
        field.required = true;
      } else {
        field.required = false;
      }
      if (!active && field.type !== 'hidden') {
        field.value = '';
        field.classList.remove('is-invalid');
      }
    });

    if (active) {
      updateUseDateConstraints();
    }
  }

  function collectCustomizeDataObject() {
    const form = getCustomizeForm();
    const data = {};
    if (!form || !isCustomizeSizeActive()) return data;

    syncGenderProperty();

    const { useDateKey, dressSizeKey } = getFormConfig();

    form.querySelectorAll('[data-customize-field]').forEach((field) => {
      if (field.disabled) return;

      const key = field.dataset.customizeKey || field.name.match(/^properties\[(.+)\]$/)?.[1];
      if (!key) return;

      let value = field.value;
      if (value == null || String(value).trim() === '') return;

      if (key === useDateKey && field.type === 'date') {
        value = formatUseDate(value);
      }

      data[key] = value;
    });

    if (!data[dressSizeKey]) {
      data[dressSizeKey] = getSelectedSizeValue() || getCustomizeSizeValues()[0] || dressSizeKey;
    }

    return data;
  }

  function collectLineItemProperties() {
    const data = collectCustomizeDataObject();
    if (!Object.keys(data).length) return {};
    return { ...data };
  }

  function validateForm() {
    if (!isCustomizeSizeActive()) return true;

    const form = getCustomizeForm();
    if (!form) return true;

    let valid = true;

    form.querySelectorAll('[data-customize-field]').forEach((field) => {
      if (field.disabled || field.type === 'hidden') return;

      const value = String(field.value || '').trim();
      if (!value) {
        field.classList.add('is-invalid');
        if (valid) field.focus();
        valid = false;
        return;
      }

      if (field.hasAttribute('data-customize-use-date') && !isUseDateAllowed(field.value)) {
        field.classList.add('is-invalid');
        if (valid) {
          field.focus();
          alert(getValidationUseDateMessage());
        }
        valid = false;
        return;
      }

      field.classList.remove('is-invalid');
    });

    return valid;
  }

  function applyState() {
    const active = isCustomizeSizeActive();
    setFormState(active);
    if (active) {
      syncGenderProperty();
    }
  }

  function scheduleUpdate() {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(applyState, 0);
  }

  function appendPropertiesToFormData(formData, properties) {
    Object.entries(properties).forEach(([key, value]) => {
      if (value == null || String(value).trim() === '') return;
      formData.delete('properties[' + key + ']');
      formData.append('properties[' + key + ']', value);
    });
  }

  function isCartAddRequest(url) {
    return typeof url === 'string' && url.includes('/cart/add.js');
  }

  function enhanceCartAddPayload(data) {
    if (!isCustomizeSizeActive()) return data;

    if (!validateForm()) {
      const error = new Error(getValidationRequiredMessage());
      error.code = 'CUSTOMIZE_VALIDATION_FAILED';
      throw error;
    }

    const props = collectLineItemProperties();

    if (data.items && Array.isArray(data.items) && data.items.length) {
      const mainItem = data.items[0];
      mainItem.properties = { ...(mainItem.properties || {}), ...props };
    } else {
      data.properties = { ...(data.properties || {}), ...props };
    }

    return data;
  }

  function enhanceCartAddBody(body) {
    if (typeof body !== 'string' || !body.trim().startsWith('{')) return body;

    try {
      return JSON.stringify(enhanceCartAddPayload(JSON.parse(body)));
    } catch (error) {
      if (error.code === 'CUSTOMIZE_VALIDATION_FAILED') throw error;
      return body;
    }
  }

  function enhanceCartAddFormData(formData) {
    if (!(formData instanceof FormData) || !isCustomizeSizeActive()) return formData;

    if (!validateForm()) {
      const error = new Error(getValidationRequiredMessage());
      error.code = 'CUSTOMIZE_VALIDATION_FAILED';
      throw error;
    }

    appendPropertiesToFormData(formData, collectLineItemProperties());
    return formData;
  }

  function enhanceCartAddInit(init) {
    if (!init?.body) return init;

    if (typeof init.body === 'string') {
      return { ...init, body: enhanceCartAddBody(init.body) };
    }

    if (init.body instanceof FormData) {
      return { ...init, body: enhanceCartAddFormData(init.body) };
    }

    return init;
  }

  function patchCartAddApi() {
    if (window.fetch.__yumecosCustomizeWrap) return;

    const previousFetch = window.fetch.bind(window);

    function patchedFetch(input, init) {
      const url = typeof input === 'string' ? input : input?.url;
      let nextInit = init;

      if (isCartAddRequest(url) && nextInit?.body) {
        try {
          nextInit = enhanceCartAddInit(nextInit);
        } catch (error) {
          if (error.code === 'CUSTOMIZE_VALIDATION_FAILED') {
            alert(error.message);
            return Promise.reject(error);
          }
          throw error;
        }
      }

      return previousFetch(input, nextInit);
    }

    patchedFetch.__yumecosCustomizeWrap = true;
    window.fetch = patchedFetch;
  }

  function scheduleCartAddPatch() {
    patchCartAddApi();
    [500, 1500, 3000].forEach((ms) => setTimeout(patchCartAddApi, ms));
  }

  function handleCustomizeInteraction(event) {
    if (!event.target.closest('[data-has-customize-size="true"]')) return;
    scheduleUpdate();
  }

  function bindEvents() {
    if (eventsBound) return;
    eventsBound = true;

    document.addEventListener('change', handleCustomizeInteraction, true);
    document.addEventListener('click', handleCustomizeInteraction, true);

    getVariantPicker()?.addEventListener('change', scheduleUpdate);

    getUseDateField()?.addEventListener('change', () => {
      const field = getUseDateField();
      if (!field || field.disabled) return;
      if (field.value && !isUseDateAllowed(field.value)) {
        field.classList.add('is-invalid');
        field.value = '';
        alert(getValidationUseDateMessage());
      } else {
        field.classList.remove('is-invalid');
      }
    });
  }

  function init() {
    if (!getCustomizeForm() || !getSizeOptionContainer()) return;
    bindEvents();
    applyState();
  }

  scheduleCartAddPatch();
  window.addEventListener('load', patchCartAddApi);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    eventsBound = false;
    init();
  });

  window.yumecosGetCustomizeLineItemProperties = function () {
    if (!isCustomizeSizeActive()) return null;
    if (!validateForm()) return null;
    const props = collectLineItemProperties();
    return props && Object.keys(props).length ? props : null;
  };

  window.yumecosHandleCustomizeAddToCart = function () {
    if (!isCustomizeSizeActive()) return false;
    if (!validateForm()) return true;
    return false;
  };
})();
